import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import { fetchTest, fetchTestFilters, clearTest, clearTestQuestion, clearTestFilter } from 'app/actions/TestActions';
import { getOnSiteEvaluationsCal, getIsLoadingOnSiteEvaluationsilters, getOnSiteEvaluationsCalFilters } from 'app/reducers';
import { Modal, Icon, Tooltip } from 'antd';
import { getEvaluationsCalFtF_, getEvaluationsCalFiltersFtF, getAsignedEmployeesFtF } from 'app/actions/OnSiteEvaluationsActions';
//import { getEmployeesByIdEmployee } from 'app/actions/CommunicationProgramActions';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';

export default function TableContainer(props) {
    const { confirm } = Modal;
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const { siteId } = useSelector(state => state.Auth);
    const { idSubdirection, employeeId } = useSelector(state => state.Auth.employeeById)

    const { classes } = props;
    const columns = [
        {
            title: 'Programa de Comunicación',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 250
        },{
            title: 'Folio Procedimiento',
            dataIndex: 'courseFolio',
            key: 'courseFolio',
            sorter: true,
            width: 150
        }, {
            title: 'Procedimiento',
            dataIndex: 'courseName',
            key: 'courseName',
            ellipsis: true,
            sorter: true,
            width: 350
        }, {
            title: 'Folio Evaluación',
            dataIndex: 'testFolio',
            key: 'testFolio',
            sorter: true,
            width: 150
        }, {
            title: 'Colaborador',
            dataIndex: 'evaluado',
            key: 'evaluado',
            ellipsis: true,
            sorter: true,
            width: 300
        }, {
            title: 'ID de la Evaluación',
            dataIndex: 'idPresentialEvaluation',
            key: 'idPresentialEvaluation',
            sorter: true,
            width: 300,
            ellipsis: true
        },
        {
            title: 'Pernocta',
            dataIndex: 'pernocta',
            key: 'pernocta',
            sorter: true,
            width: 150
        },
        {
            title: 'Fecha Efectiva',
            dataIndex: 'fechaEfectiva',
            key: 'fechaEfectiva',
            sorter: true,
            width: 150,
            render: (fechaEfectiva) => {
                if (fechaEfectiva) {
                    return moment(fechaEfectiva).locale('es').format('L')
                } else {
                    return <label></label>
                }
            }
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName',
            sorter: true,
            width: 150
        },
        {
            title: 'Acciones',
            dataIndex: 'idTest',
            key: 'actions',
            fixed: 'right',
            width: 120,
            render: (key, params) => (
                <div>

                    {
                        params.idPresentialEvaluationStatus === 1 ?
                        <div className={classes.buttons}>
                        <Tooltip placement="bottomLeft" title={'Aprobado'}>
                        <IconButton className={classes.editIcon} disabled={params.statusName != "Pendiente"} onClick={() => showTabEdit(params, "Aprobar", 2)}>
                            <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip placement="bottomLeft" title={'No Aprobado'}>
                        <IconButton className={classes.editIcon} disabled={params.statusName != "Pendiente"} onClick={() => showTabEdit(params, "Reprobar", 3)}>
                            <Icon type="close-circle" theme="twoTone" twoToneColor='#eb4034' />
                        </IconButton>
                    </Tooltip>
                    <Tooltip placement="bottomLeft" title={'Cancelado'}>
                        <IconButton className={classes.editIcon} disabled={params.statusName != "Pendiente"} onClick={() => showTabEdit(params, "Cancelar", 4)}>
                            <Icon type="stop" theme="twoTone" twoToneColor='#eb4034' />
                        </IconButton>
                    </Tooltip> 
                    </div>
                            :
                            null
                    }
                   
                </div>
            )
        }
    ];

    const showTabEdit = (id, param, estado) => {
        // dispatch(getEmployeesByIdEmployee({
        //     idCourse: id.idCourse,
        //     idContract: null,
        //     idWork: null
        // }));
        props.setShowModal({
            visible: true,
            data: id,
            title: param,
            estado: estado
        })
        // dispatch(clearTestQuestion());
        // dispatch(clearTestFilter());
        // dispatch(fetchTestFilters(idSubdirection, employeeId));
    }

    let evaluations = useSelector(getOnSiteEvaluationsCal);
    let isLoading = useSelector(getIsLoadingOnSiteEvaluationsilters);
    let testFilter = useSelector(getOnSiteEvaluationsCalFilters);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(evaluations)) fetchTestAction();
        if (isEmpty(getOnSiteEvaluationsCalFilters)) fetchTestFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        const obj = {
            SubdirectionId: idSubdirection,
            EmployeeId: employeeId,
            DateApply: (props.formData.dateSel === undefined) ? '' : props.formData.dateSel,
            Fichas: (props.formData.employeeSel === undefined) ? '' : props.formData.employeeSel,
            TestFolio: (props.formData.testFolioSel === undefined) ? '' : props.formData.testFolioSel,
            IdPresentialEvaluation: (props.formData.preEvaluationSel === undefined) ? '' : props.formData.preEvaluationSel,
            Pernocta: (props.formData.pernoctaSel === undefined) ? '' : props.formData.pernoctaSel,
            CourseFolio: (props.formData.folioSelected === undefined) ? '' : props.formData.folioSelected,
            sortColumn: column,
            sortDir: order,
            offset: ((pagination.current - 1) * pagination.pageSize),
            limit: pagination.pageSize
        };
        dispatch(getEvaluationsCalFtF_(obj));


    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && evaluations.length > 0) {
            pagination.total = evaluations[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }
    const fetchTestAction = () => dispatch(getEvaluationsCalFtF_({
        offset: offset,
        limit: limit,
        EmployeeId: employeeId,
        SubdirectionId: idSubdirection,
        sortColumn: '',
        sortDir: '',

    }));
    const fetchTestFilterAction = () => dispatch(getEvaluationsCalFiltersFtF({
        EmployeeId: employeeId,
        SubdirectionId: idSubdirection
    }))
    evaluations.map(item => item['key'] = item.idCommunication);
    return (props.children({ pagination: pagination, cols: columns, evaluations, testFilter, isLoading, handleTableChange: handleTableChange }));
}